import React from 'react'
import style from './articles.style'

const DS5custreports = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>5 полезных кастомных отчетов в&nbsp;Google Analytics </h2>
      <p>
        Для того, чтобы эффективно пользоваться кастомными отчетами, нужно
        определиться с&nbsp;целями и&nbsp;задачами. Какие конкретно показатели
        вам необходимо отслеживать? Почему именно эти показатели? Как это
        поможет вам оптимизировать работу рекламных инструментов?
      </p>
      <p>
        В этой статье предлагаем разобрать 5 полезных кастомных отчетов. Условно
        все веб-сайты можно разделить на&nbsp;следующие направления:
      </p>
      <ul>
        <li>
          Электронную коммерцию (коммерческие сайты с&nbsp;циклом продажи от
          поиска товара до его оплаты или формирования заказа онлайн);
        </li>
        <li>
          Сайты заказов по заявкам (коммерческий сайты с&nbsp;конечной целью
          получения контакта клиента, для дальнейшего ведения продажи вне
          сайта);
        </li>
        <li>
          Информационные сайты (некоммерческие или условно-некоммерческие сайты
          с&nbsp;целью максимально длительного пребывания пользователей
          на&nbsp;сайте. в&nbsp;качестве дополнительной цели могут выступать
          клики по рекламным ссылкам\баннерам).
        </li>
      </ul>
      <p>
        Рассмотренные ниже отчеты при правильной настройке подойдут для сайтов
        электронной коммерции и&nbsp;сайтов заказов по заявкам. Стоит отметить,
        что для каждого из отчетов потребуется провести дополнительные настройки
        в&nbsp;Google Analytics. Что должно быть настроено:
      </p>
      <ul>
        <li>Электронная коммерция (для интернет-магазина).</li>
        <li>
          Импорт данных из crm системы. Таким образом, вы получите “Вид сверху”
          на&nbsp;всю воронку продаж в&nbsp;разрезе типов трафика, включая
          указание рентабельности инвестиций.
        </li>
        <li>Импорт расходов, по всем рекламным площадкам.</li>
      </ul>
      <h3>1. Отчет эффективности по типам трафика </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/niqijc.png" alt="true" />
        <figcaption>Пример отчета</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/niqijc&amp;sa=D&amp;ust=1558095534032000">http://prntscr.com/niqijc</a> (подпись: Пример отчета)</p> */}
      <h4>Чем полезен: </h4>
      <p>
        Этот отчет помогает понять, что из ваших активностей в&nbsp;вебе
        приносит вам больше продаж: seo оптимизация и&nbsp;работа над контентом;
        платный трафик; smm или что-то еще. Для простоты анализа отчет не
        содержит детальных данных по конкретным источникам или рекламным
        кампаниям.
      </p>
      <h4>Настройка отчета: </h4>
      <ul>
        <li>Создайте новый отчет на&nbsp;вкладке “Мои отчеты”.</li>
        <li>Используйте одну вкладку с&nbsp;типом “Анализ”.</li>
        <li>В качестве анализируемых параметров выберите “Тип трафика”.</li>
        <li>
          В качестве показателей выберите:
          <ul>
            <li>Доход;</li>
            <li>
              Транзакции (также можно добавить конверсии, чтобы получать данные
              по продажам из CRM);
            </li>
            <li>
              Количество добавлений в&nbsp;корзину (для электронной коммерции);
            </li>
            <li>Сеансы;</li>
            <li>Пользователи;</li>
            <li>Стоимость;</li>
            <li>Рентабельность инвестиций в&nbsp;рекламу.</li>
          </ul>
        </li>
        <li>Фильтр оставьте пустым.</li>
        <li>Выберите представление в&nbsp;которое импортируются данные.</li>
      </ul>
      <h4>Окно настройки будет выглядеть так: </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/niqmkf.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/niqmkf&amp;sa=D&amp;ust=1558095534035000">http://prntscr.com/niqmkf</a></p> */}
      <h3>2. Отчет эффективности по платному трафику </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir3ii.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “По источнику”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir3ii&amp;sa=D&amp;ust=1558095534036000">http://prntscr.com/nir3ii</a> (подпись: Пример отчета. Вкладка “По источнику”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir3ve.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “По кампаниям”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir3ve&amp;sa=D&amp;ust=1558095534036000">http://prntscr.com/nir3ve</a> (подпись: Пример отчета. Вкладка “По кампаниям”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir4kp.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Канал/кампания”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir4kp&amp;sa=D&amp;ust=1558095534036000">http://prntscr.com/nir4kp</a> (подпись: Пример отчета. Вкладка “Канал/кампания”)</p> */}
      <h4>Чем полезен: </h4>
      <p>
        Поможет понять, какие платные каналы трафика приносят вам больше продаж.
        Для простоты анализа отчет состоит из 3&nbsp;вкладок&nbsp;с разной
        степенью глубины данных.
      </p>
      <h4>Настройка отчета: </h4>
      <h5>Первая вкладка “По источнику”:</h5>
      <ul>
        <li>Создайте новый отчет на&nbsp;вкладке “Мои отчеты”.</li>
        <li>Используйте вкладки с&nbsp;типом “Анализ”.</li>
        <li>В качестве анализируемых параметров выберите “Источник”.</li>
        <li>
          В качестве показателей укажите:
          <ul>
            <li>Доход;</li>
            <li>Транзакции (или конверсию в&nbsp;заявку);</li>
            <li>
              Количество добавлений в&nbsp;корзину (для электронной коммерции);
            </li>
            <li>Сеансы;</li>
            <li>Пользователи;</li>
            <li>Стоимость;</li>
            <li>Рентабельность инвестиций в&nbsp;рекламу.</li>
          </ul>
        </li>
        <li>В фильтре укажите “Тип трафика - точное соответствие - paid”.</li>
        <li>Выберите представление в&nbsp;которое импортируются данные.</li>
        <li>Назовите вкладку “По источнику”.</li>
      </ul>
      <p>Окно настройки первой вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir2qz.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir2qz&amp;sa=D&amp;ust=1558095534040000">http://prntscr.com/nir2qz</a></p> */}
      <h5>Вторая вкладка “По кампаниям”:</h5>
      <ul>
        <li>Нажмите на&nbsp;кнопку “Создать копию вкладки”.</li>
        <li>Назовите вкладку “По кампаниям”.</li>
        <li>Измените анализируемый параметр на&nbsp;“По кампаниям”.</li>
      </ul>
      <p>Окно настройки второй вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir2y8.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir2y8&amp;sa=D&amp;ust=1558095534041000">http://prntscr.com/nir2y8</a></p> */}
      <h5>Третья вкладка “Канал/кампания”:</h5>
      <ul>
        <li>Нажмите на&nbsp;кнопку “Создать копию вкладки”.</li>
        <li>Назовите вкладку “Канал\Кампания”.</li>
        <li>
          Измените анализируемый параметр на&nbsp;“Источник” и&nbsp;добавьте
          дополнительный анализируемый параметр “Кампания”.
        </li>
      </ul>
      <p>Окно настройки третьей вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nir353.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nir353&amp;sa=D&amp;ust=1558095534042000">http://prntscr.com/nir353</a></p> */}
      <h3>3. Отчет эффективности по поисковому трафику </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nitliu.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Поисковые системы”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nitliu&amp;sa=D&amp;ust=1558095534043000">http://prntscr.com/nitliu</a> (подпись: Пример отчета. Вкладка “Поисковые системы”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nitlpo.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Поисковые запросы”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nitlpo&amp;sa=D&amp;ust=1558095534043000">http://prntscr.com/nitlpo</a> (подпись: Пример отчета. Вкладка “Поисковые запросы”)</p> */}
      <h4>Чем полезен: </h4>
      <p>
        Отслеживайте эффективность отдельных поисковых систем и&nbsp;поисковых
        запросом (из за шифрования запросов поисковыми системами данные могут
        быть с&nbsp;большой погрешностью). с&nbsp;помощью ROMI center, можно
        вручную учитывать расходы на&nbsp;SEO специалиста, копирайтера
        и&nbsp;т.д. Это позволит приблизиться к&nbsp;полноценной сквозной
        аналитике и&nbsp;с большим пониманием распределять бюджет
        на&nbsp;улучшение SEO показателей сайта.
      </p>
      <h4>Настройка отчета: </h4>
      <h5>Первая вкладка “Поисковые системы”:</h5>
      <ul>
        <li>Создайте новый отчет на&nbsp;вкладке “Мои отчеты”.</li>
        <li>Используйте вкладки с&nbsp;типом “Анализ”.</li>
        <li>В качестве анализируемых параметров выберите “Источник”.</li>
        <li>
          В качестве показателей укажите:
          <ul>
            <li>Доход;</li>
            <li>Транзакции (или конверсию в&nbsp;заявку);</li>
            <li>
              Количество добавлений в&nbsp;корзину (для электронной коммерции);
            </li>
            <li>Сеансы;</li>
            <li>Пользователи;</li>
            <li>Показатель отказов;</li>
            <li>Просмотры страниц;</li>
            <li>Средняя длительность сеанса;</li>
            <li>Стоимость;</li>
            <li>Рентабельность инвестиций в&nbsp;рекламу.</li>
          </ul>
        </li>
        <li>
          В фильтре укажите “Тип трафика - точное соответствие - organic”.
        </li>
        <li>Выберите представление, в&nbsp;которое импортируются данные.</li>
        <li>Назовите вкладку “Поисковые системы”.</li>
      </ul>
      <p>Окно настройки первой вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nitjht.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nitjht&amp;sa=D&amp;ust=1558095534047000">http://prntscr.com/nitjht</a></p> */}
      <h5>Вторая вкладка “Поисковые запросы”:</h5>
      <ul>
        <li>Нажмите на&nbsp;кнопку “Создать копию вкладки”.</li>
        <li>Назовите вкладку “Поисковые запросы”.</li>
        <li>
          Измените анализируемые параметры на&nbsp;“Ключевое слово” + “Источник”
          (для уточнения поисковой системы).
        </li>
      </ul>
      <p>Окно настройки второй вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nitkn3.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nitkn3&amp;sa=D&amp;ust=1558095534048000">http://prntscr.com/nitkn3</a></p> */}
      <h3>4. Отчет для корректировок ставок по гео </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlabym.png" alt="true" />
        <figcaption>Пример отчета</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlabym&amp;sa=D&amp;ust=1558095534049000">http://prntscr.com/nlabym</a> (подпись: Пример отчета)</p> */}
      <h4>Чем полезен: </h4>
      <p>
        Поможет вам правильно указывать корректировки ставок по географии
        в&nbsp;ваших рекламных кампаниях (если вы показываете рекламу
        на&nbsp;несколько городов).
      </p>
      <h4>Настройка отчета: </h4>
      <ul>
        <li>Создайте новый отчет на&nbsp;вкладке “Мои отчеты”.</li>
        <li>
          Используйте вкладки с&nbsp;типом “Наложение данных на&nbsp;карту”.
        </li>
        <li>
          Выберите удобный уровень масштабирования (как правило это “Страна”)
          и&nbsp;локацию этого уровня (в примеры выбрано “Russia”).
        </li>
        <li>
          Выберите параметр по которому данные будут распределены (в примере
          взяты регионы “России”).
        </li>
        <li>
          В качестве показателей укажите:
          <ul>
            <li>Доход;</li>
            <li>Транзакции (или конверсию в&nbsp;заявку);</li>
            <li>
              Количество добавлений в&nbsp;корзину (для электронной коммерции);
            </li>
            <li>Сеансы;</li>
            <li>Пользователи;</li>
            <li>Коэффициент транзакций;</li>
            <li>Коэффициент выбранных товаров;</li>
            <li>Показатель отказов;</li>
            <li>Средняя длительность сеанса.</li>
          </ul>
        </li>
        <li>В фильтре укажите “Тип трафика - точное соответствие - paid”.</li>
        <li>Выберите представление, в&nbsp;которое импортируются данные.</li>
        <li>Назовите вкладку “Гео”.</li>
      </ul>
      <h4>Окно настройки будет выглядеть так: </h4>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlabu5.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlabu5&amp;sa=D&amp;ust=1558095534053000">http://prntscr.com/nlabu5</a></p> */}
      <h3>5. Отчет для корректировок ставок </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlajcn.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Устройства”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlajcn&amp;sa=D&amp;ust=1558095534054000">http://prntscr.com/nlajcn</a> (подпись: Пример отчета. Вкладка “Устройства”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlaji0.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “Время суток”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlaji0&amp;sa=D&amp;ust=1558095534054000">http://prntscr.com/nlaji0</a> (подпись: Пример отчета. Вкладка “Время суток”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlajmx.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “День недели”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlajmx&amp;sa=D&amp;ust=1558095534055000">http://prntscr.com/nlajmx</a> (подпись: Пример отчета. Вкладка “День недели”)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlajt6.png" alt="true" />
        <figcaption>Пример отчета. Вкладка “День месяца”</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlajt6&amp;sa=D&amp;ust=1558095534055000">http://prntscr.com/nlajt6</a> (подпись: Пример отчета. Вкладка “День месяца”)</p> */}
      <h4>Чем полезен: </h4>
      <p>
        Поможет вам правильно указывать корректировки ставок (по устройствам,
        времени клика) в&nbsp;ваших рекламных кампаниях. Например, возможно, вы
        заметите, что по понедельникам конверсия в&nbsp;два-три раза ниже, чем
        в&nbsp;остальные дни, а&nbsp;в среду конверсия повышается. Из этого
        следует, что имеет снизить стоимость клика в&nbsp;понедельник
        на&nbsp;50-70%, а&nbsp;в среду повысить. Если вы заметите большую
        разницу в&nbsp;конверсии на&nbsp;различных устройствах, имеет смысл
        проводить корректировку ставок по устройствам.
      </p>
      <h4>Настройка отчета: </h4>
      <h5>Первая вкладка “Устройства”:</h5>
      <ul>
        <li>Создайте новый отчет на&nbsp;вкладке “Мои отчеты”.</li>
        <li>Используем вкладки с&nbsp;типом “Анализ”.</li>
        <li>В качестве анализируемых параметров выберите “Тип устройства”.</li>
        <li>
          В качестве показателей укажите:
          <ul>
            <li>Доход;</li>
            <li>Транзакции (или конверсию в&nbsp;заявку);</li>
            <li>
              Количество добавлений в&nbsp;корзину (для электронной коммерции);
            </li>
            <li>Сеансы;</li>
            <li>Пользователи;</li>
            <li>Стоимость;</li>
            <li>Рентабельность инвестиций в&nbsp;рекламу;</li>
            <li>Коэффициент транзакций;</li>
            <li>Коэффициент выбранных товаров;</li>
            <li>Показатель отказов.</li>
          </ul>
        </li>
        <li>В фильтре укажите “Тип трафика - точное соответствие - paid”.</li>
        <li>Выберите представление в&nbsp;которое импортируются данные.</li>
        <li>Назовите вкладку “Устройства”.</li>
      </ul>
      <p>Окно настройки первой вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlahj2.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlahj2&amp;sa=D&amp;ust=1558095534059000">http://prntscr.com/nlahj2</a></p> */}
      <h5>Вторая вкладка “Время суток”:</h5>
      <ul>
        <li>Нажмите на&nbsp;кнопку “Создать копию вкладки”.</li>
        <li>Назовите вкладку “Время суток”.</li>
        <li>Измените анализируемый параметр на&nbsp;“Час”.</li>
      </ul>
      <p>Окно настройки второй вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlai2r.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlai2r&amp;sa=D&amp;ust=1558095534061000">http://prntscr.com/nlai2r</a></p> */}
      <h5>Третья вкладка “День недели”:</h5>
      <ul>
        <li>Нажмите на&nbsp;кнопку “Создать копию вкладки”.</li>
        <li>Назовите вкладку “День недели”.</li>
        <li>Измените анализируемый параметр на&nbsp;“День недели”.</li>
      </ul>
      <p>Окно настройки третьей вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlaigw.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlaigw&amp;sa=D&amp;ust=1558095534062000">http://prntscr.com/nlaigw</a></p> */}
      <h5>Четвертая вкладка “День месяца”:</h5>
      <ul>
        <li>Нажмите на&nbsp;кнопку “Создать копию вкладки”.</li>
        <li>Назовите вкладку “День месяца”.</li>
        <li>Измените анализируемый параметр на&nbsp;“День месяца”.</li>
      </ul>
      <p>Окно настройки четвертой вкладки будет выглядеть так:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nlaixh.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nlaixh&amp;sa=D&amp;ust=1558095534063000">http://prntscr.com/nlaixh</a></p> */}
    </article>
  )
}

export default style(DS5custreports)
